import { Checkbox, Space } from 'antd';
import { CustomCheckboxGroupProps } from '../../interfaces';
import { CheckboxValueType } from 'antd/es/checkbox/Group';
import CustomCheckbox from '../controls/Checkbox';
import './styles.scss';

const CustomCheckboxGroup: React.FC<CustomCheckboxGroupProps> = props => {
  const {
    options,
    onChange,
    wrap = true,
    customDirection = 'horizontal',
    ...rest
  } = props;

  const handleChange = (e: CheckboxValueType[]) => {
    onChange?.(e);
  };

  return (
    <Checkbox.Group
      {...rest}
      onChange={handleChange}
      options={options}
      className={`custom-checkbox-group ${customDirection}`}
    >
      <Space direction={customDirection} wrap={wrap}>
        {options?.map((option, index) => (
          <CustomCheckbox key={index} value={option.value}>
            {option.label}
          </CustomCheckbox>
        ))}
      </Space>
    </Checkbox.Group>
  );
};

export default CustomCheckboxGroup;
